import { z } from "zod";

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
const reqStrSchema = z.string().min(1, { message: "این فیلد الزامی است" });

const datereqStrSchema = z.string().transform((val) => (val == null ? "" : val));

const dateSchema = datereqStrSchema
  .refine((val) => val !== "", {
    message: "این فیلد الزامی است",
  })
  .refine((val) => dateRegex.test(val), {
    message: "فرمت تاریخ نامعتبر است.",
  });

export const authSchema = z.object({
  is_iranian: z.boolean(),
  first_name_fa: reqStrSchema,
  first_name_en: reqStrSchema,
  last_name_fa: reqStrSchema,
  last_name_en: reqStrSchema,
  father_name_fa: reqStrSchema,
  father_name_en: reqStrSchema,
  birthdate: dateSchema,
  national_code: z.string().min(1, { message: "این فیلد الزامی است" }).length(10, "کد ملی باید ده رقمی باشد"),
  email: z
    .string()
    .transform((val) => (val === "" ? null : val))
    .refine((val) => val === null || z.string().email().safeParse(val).success, {
      message: "فرمت ایمیل صحیح نمی باشد",
    }),
  profile_picture: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
  }),

  top_national_card_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس کارت ملی الزامی است`,
      }),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس کارت ملی الزامی است`,
      }),
  }),
  first_birth_certificate_page_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس شناسنامه الزامی است`,
      }),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس شناسنامه الزامی است`,
      }),
  }),
});

export const authForeingSchema = z.object({
  is_iranian: z.boolean(),
  first_name_fa: z.string().min(1, { message: "این فیلد الزامی است" }),
  first_name_en: z.string().min(1, { message: "این فیلد الزامی است" }),
  last_name_fa: z.string().min(1, { message: "این فیلد الزامی است" }),
  last_name_en: z.string().min(1, { message: "این فیلد الزامی است" }),
  father_name_fa: z.string().min(1, { message: "این فیلد الزامی است" }),
  father_name_en: z.string().min(1, { message: "این فیلد الزامی است" }),
  foreign_pervasive_code: z
    .string()
    .min(1, { message: "این فیلد الزامی است" })
    .length(12, "کد فراگیر باید دوازده رقمی باشد"),
  countrycode_id: z.union([
    z.string().min(1, { message: "این فیلد الزامی است" }),
    z.number().min(1, { message: "این فیلد الزامی است" }),
  ]),
  birthdate: dateSchema,
  passport_expire_date: dateSchema,
  email: z
    .string()
    .transform((val) => (val === "" ? null : val))
    .refine((val) => val === null || z.string().email().safeParse(val).success, {
      message: "فرمت ایمیل صحیح نمی باشد",
    }),
  passport_number: z
    .string()
    .min(1, { message: "این فیلد الزامی است" })
    .length(9, " شماره گذرنامه باید 8 رقمی باشد"),
  profile_picture: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e)),
  }),
  passport_image: z.object({
    url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس گذرنامه الزامی است`,
      }),
    preview_url: z
      .string()
      .optional()
      .transform((e) => (e === undefined ? "" : e))
      .refine((file) => file !== "", {
        message: `عکس گذرنامه الزامی است`,
      }),
  }),
});
